
import { defineComponent, ref } from 'vue';
import { ElLoading } from 'element-plus';
import store from '@/store/index';

export default defineComponent({
  name: 'MyIframeComponent',
  setup() {
    const src = ref<string>("")
    const loading = null as any
    return {
      src,
      loading,
      
    }
  },
  methods: {
    resetSrc(url: string): void {
      this.src = url;
      this.load();
    },
    load(): void {
      this.loading = ElLoading.service({
        lock: true,
        text: 'loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
        // fullscreen: false,
        target: document.querySelector('#main-container') as HTMLElement,
      });
      this.loading.start();
    },
    onLoaded(): void {
      if (this.loading) {
        this.loading.finish();
      }
    },
  },
  mounted(): void {
    this.resetSrc(store.state.iframe.iframeUrl);
  },
  watch: {
    $route(val: any, oldVal: any): void {
      this.resetSrc(store.state.iframe.iframeUrl);
    },
  },
});
